const MapConfig = {
  center: {
    lat: parseFloat(process.env.VUE_APP_MAP_CENTER_LAT as string),
    lng: parseFloat(process.env.VUE_APP_MAP_CENTER_LNG as string),
  },
};

export default MapConfig;
